export function todayKey(): string {
  return new Date().toISOString().slice(0, 10);
}

export function addDays(key: string, days: number): string {
  const d = new Date(key);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function startOfWeek(key: string): string {
  const day = new Date(key).getUTCDay(); // 0=Sun..6=Sat
  return addDays(key, day === 0 ? -6 : 1 - day); // Monday-start
}

export function weekDates(startKey: string): string[] {
  return Array.from({ length: 7 }, (_, i) => addDays(startKey, i));
}
